import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForYouSection() {
  return <>
      {/* FOR YOU */}
      <section className="bg-green-50 py-16 sm:py-24" data-id="element-171">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
          <div className="max-w-2xl mx-auto" data-id="element-173">
            <div className="text-center mb-10" data-id="element-174">
              <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-175">
                Trimora Es Para Ti Si…
              </h2>
            </div>

            <div className="bg-card rounded-2xl shadow-sm border border-green-100 p-8 flex flex-col gap-4" data-id="element-176">
              <div className="flex items-start gap-4" data-id="element-177">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-178" />
                <span className="text-foreground text-lg" data-id="element-179">
                  Tienes más de 35 años
                </span>
              </div>
              <div className="h-px bg-border" data-id="element-180"></div>
              <div className="flex items-start gap-4" data-id="element-181">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-182" />
                <span className="text-foreground text-lg" data-id="element-183">
                  Sientes que tu metabolismo ya no responde igual
                </span>
              </div>
              <div className="h-px bg-border" data-id="element-184"></div>
              <div className="flex items-start gap-4" data-id="element-185">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-186" />
                <span className="text-foreground text-lg" data-id="element-187">
                  Luchas con antojos constantes
                </span>
              </div>
              <div className="h-px bg-border" data-id="element-188"></div>
              <div className="flex items-start gap-4" data-id="element-189">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-190" />
                <span className="text-foreground text-lg" data-id="element-191">
                  Quieres apoyo diario sin dietas extremas
                </span>
              </div>
              <div className="h-px bg-border" data-id="element-192"></div>
              <div className="flex items-start gap-4" data-id="element-193">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-194" />
                <span className="text-foreground text-lg" data-id="element-195">
                  Buscas una solución sencilla y práctica
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* NOT FOR YOU */}
      <section className="bg-background py-16 sm:py-24" data-id="element-196">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
          <div className="max-w-2xl mx-auto" data-id="element-198">
            <div className="text-center mb-10" data-id="element-199">
              <h2 className="text-3xl sm:text-4xl font-bold text-foreground" data-id="element-200">
                Trimora No Es Para Ti Si…
              </h2>
              <p className="mt-3 text-muted-foreground" data-id="element-201">
                Preferimos ser honestos. Trimora no es para todo el mundo.
              </p>
            </div>

            <div className="bg-muted rounded-2xl border border-border p-8 flex flex-col gap-4" data-id="element-202">
              <div className="flex items-start gap-4" data-id="element-203">
                <XCircleIcon className="w-6 h-6 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-204" />
                <span className="text-foreground text-lg" data-id="element-205">
                  Buscas resultados milagro en 3 días
                </span>
              </div>
              <div className="h-px bg-border" data-id="element-206"></div>
              <div className="flex items-start gap-4" data-id="element-207">
                <XCircleIcon className="w-6 h-6 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-208" />
                <span className="text-foreground text-lg" data-id="element-209">
                  No estás dispuesta/o a mantener hábitos básicos saludables
                </span>
              </div>
              <div className="h-px bg-border" data-id="element-210"></div>
              <div className="flex items-start gap-4" data-id="element-211">
                <XCircleIcon className="w-6 h-6 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-212" />
                <span className="text-foreground text-lg" data-id="element-213">
                  Esperas que un producto sustituya completamente tu estilo de
                  vida
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
}